import { Link } from "react-router-dom";
import { Truck, Mail, Phone, MapPin } from "lucide-react";
import { LINKS, COMPANY } from "@/config/links";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 bg-[#040914]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2.5" data-testid="footer-logo">
              <span className="h-9 w-9 rounded-xl bg-[#00274C] border border-white/10 grid place-items-center">
                <Truck className="h-4.5 w-4.5 text-[#FFCB05]" strokeWidth={2.25} />
              </span>
              <span className="font-display text-lg font-semibold text-white">
                Linehaul <span className="text-[#FFCB05]">Books</span>
              </span>
            </Link>
            <p className="mt-5 max-w-sm text-sm text-[#9CA3AF] leading-relaxed">
              Always within reach. Never in the way. Boutique bookkeeping and back-office for over-the-road truckers, owner-operators, and small fleets.
            </p>
            <div className="mt-6 space-y-2.5 text-sm text-[#9CA3AF]">
              <div className="flex items-center gap-2.5"><Mail className="h-4 w-4 text-[#FFCB05]" /> {COMPANY.email}</div>
              <div className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-[#FFCB05]" /> {COMPANY.phone}</div>
              <div className="flex items-center gap-2.5"><MapPin className="h-4 w-4 text-[#FFCB05]" /> {COMPANY.location}</div>
            </div>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs font-semibold tracking-[0.15em] uppercase text-[#FFCB05]">Firm</p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/" data-testid="footer-link-home" className="text-[#9CA3AF] hover:text-white">Home</Link></li>
              <li><Link to="/services" data-testid="footer-link-services" className="text-[#9CA3AF] hover:text-white">Services</Link></li>
              <li><Link to="/logbook" data-testid="footer-link-logbook" className="text-[#9CA3AF] hover:text-white">The Logbook</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="text-[#9CA3AF] hover:text-white">About</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="text-[#9CA3AF] hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs font-semibold tracking-[0.15em] uppercase text-[#FFCB05]">Clients</p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/portal" data-testid="footer-link-portal" className="text-[#9CA3AF] hover:text-white">Client Portal</Link></li>
              <li><a href={LINKS.discoveryCall} target="_blank" rel="noreferrer" data-testid="footer-link-calendly" className="text-[#9CA3AF] hover:text-white">See if Linehaul is a fit</a></li>
              <li><a href={LINKS.qbo} target="_blank" rel="noreferrer" data-testid="footer-link-qbo" className="text-[#9CA3AF] hover:text-white">QuickBooks Online</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-semibold tracking-[0.15em] uppercase text-[#FFCB05]">Ready to start?</p>
            <p className="mt-3 text-sm text-[#9CA3AF]">See the services and pricing, then book the 30-minute call.</p>
            <Link
              to="/services"
              data-testid="footer-get-started-btn"
              className="mt-5 inline-flex items-center justify-center px-5 py-2.5 rounded-full text-sm font-semibold bg-[#FFCB05] text-[#040914] hover:bg-[#FFD633] transition-colors"
            >
              Get Started
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-[#6B7280]">© {new Date().getFullYear()} Linehaul Books. All rights reserved.</p>
          <p className="text-xs text-[#6B7280]">{COMPANY.hours}</p>
        </div>
      </div>
    </footer>
  );
}
